import React, { useState, useCallback, useMemo } from 'react';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';
import Table from '../components/Table';
import { useFetchWorkloadReport } from '../hooks/useFetch';

const { RangePicker } = DatePicker;

const WorkloadReportPage = () => {
  const today = useMemo(() => dayjs(), []);
  const [selectedDate, setSelectedDate] = useState([today, today]);
  const { mutateAsync: listWorkloadReport, isLoading } = useFetchWorkloadReport();
  const [reportResult, setReportResult] = useState({
    summary: [],
    grandTotal: 0,
    systemByCase: [],
  });

  const handleClearFilters = useCallback(() => {
    setSelectedDate([today, today]);
  }, [today]);

  const handleSearch = useCallback(async () => {
    const startDate = selectedDate[0].format('YYYY-MM-DD');
    const endDate = selectedDate[1].format('YYYY-MM-DD');
    try {
      const res = await listWorkloadReport({ startDate, endDate });
      setReportResult({
        summary: res.result?.summary || [],
        grandTotal: res.result?.grandTotal || 0,
        systemByCase: res.result?.systemByCase || [],
      });
    } catch (_) {}
  }, [selectedDate, listWorkloadReport]);

  return (
    <div style={{ padding: 16, background: '#f5f5f5', minHeight: '100vh', marginLeft: 16 }}>
      <div style={{ marginBottom: 20 }}>
        <h1
          style={{
            margin: 0,
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#212121',
            letterSpacing: '0.5px',
            lineHeight: 1.2,
          }}
        >
          รายงาน Workload
        </h1>
        <p style={{ margin: '8px 0 0', color: '#666' }}>
          สรุปน้ำหนักงานรายบุคคล แยกตามประเภทเคส และรายวัน (% เทียบจาก workload ทั้งระบบ / workload แต่ละประเภทเคส)
        </p>
      </div>

      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
            gap: 16,
            alignItems: 'end',
          }}
        >
          <div style={{ marginBottom: 20 }}>
            <RangePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
              allowClear={false}
            />
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
            <Button type="primary" onClick={handleSearch}>
              ค้นหา
            </Button>
            <Button onClick={handleClearFilters}>ล้างค่า</Button>
          </div>
        </div>

        <Table
          data={reportResult.summary}
          grandTotal={reportResult.grandTotal}
          systemByCase={reportResult.systemByCase}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default WorkloadReportPage;
